import { render, staticRenderFns } from "./InventoryReceiptsForm.vue?vue&type=template&id=980b0f82"
import script from "./InventoryReceiptsForm.vue?vue&type=script&lang=js"
export * from "./InventoryReceiptsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports